<template>
  <v-tooltip
    color="grey lighten-2"
    v-model="showCopyUrlMessage"
    v-bind="{ disabled: disabled || !showCopyUrlMessage }"
    bottom
    nudge-left="35px"
  >
    <a v-if="!isButton" slot="activator" @click="copyUrl">
      <img
        :src="imageSrc"
        alt="copy-url"
        :width="iconSize"
        :height="iconSize"
      />
    </a>
    <v-btn
      v-if="isButton"
      slot="activator"
      @click="copyUrl"
      :style="{ 'text-transform': 'none' }"
    >
      {{ this.lang.copy }}
    </v-btn>
    <span class="black--text">{{ this.lang.copy_url }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "vc-share-copy-url-share-icon",
  props: {
    srcUrl: {
      type: String,
      default: ""
    },
    iconSize: {
      type: String,
      default: "35px"
    },
    imageClass: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isButton: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => {
        return {
          copy: "コピー",
          copy_url: "URLをコピーしました。"
        };
      }
    }
  },
  data: function() {
    return {
      imageSrc: require("./assets/ph_copy_url.png"),
      showCopyUrlMessage: false
    };
  },
  methods: {
    copyUrl: function(event) {
      event.preventDefault();

      if (this.disabled) {
        return;
      }

      let copyTargetElement = document.createElement("div");
      copyTargetElement.appendChild(
        document.createElement("pre")
      ).textContent = this.srcUrl;

      copyTargetElement.style.position = "absolute";

      let rect = this.$el.getBoundingClientRect();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let thisOffsetTop = rect.top + scrollTop;

      copyTargetElement.style.top = thisOffsetTop + "px";
      copyTargetElement.style.left = "-9999px";
      copyTargetElement.display = "none";

      document.body.appendChild(copyTargetElement);
      document.getSelection().selectAllChildren(copyTargetElement);

      document.execCommand("copy");
      copyTargetElement.parentNode.removeChild(copyTargetElement);

      this.showCopyUrlMessage = true;
    }
  }
};
</script>

<style module>
.shareIcon:hover {
  opacity: 0.8;
}
</style>
